const STATUS_LABEL = {
  ENDED: '已結束',
  ABANDONED: '已取消',
};

function formatWhen(item) {
  const raw = item?.endedAt || item?.abandonedAt || item?.startedAt;
  if (!raw) return '—';
  try {
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return String(raw);
    return d.toLocaleString();
  } catch {
    return String(raw);
  }
}

export default function SupportSessionHistoryPanel({
  items,
  loading,
  error,
  open,
  onToggle,
  selectedSessionId,
  onSelect,
  compact = false,
}) {
  return (
    <div className={`support-history${compact ? ' support-history--compact' : ''}`}>
      <button type="button" className="support-history__toggle" onClick={onToggle}>
        {open
          ? (compact ? '收合歷史' : '收合歷史紀錄')
          : (compact ? '歷史紀錄' : '歷史客服紀錄')}
        {!open && items?.length ? `（${items.length}）` : ''}
      </button>
      {open ? (
        <div className="support-history__body">
          {loading ? <div className="support-history__hint">載入中…</div> : null}
          {error ? <div className="support-history__error">{error}</div> : null}
          {!loading && !(items || []).length ? (
            <div className="support-history__hint">尚無歷史客服紀錄</div>
          ) : null}
          <ul className="support-history__list">
            {(items || []).map((item) => {
              const selected = selectedSessionId != null
                && String(selectedSessionId) === String(item.sessionId);
              return (
                <li key={item.sessionId}>
                  <button
                    type="button"
                    className={`support-history__item${selected ? ' is-selected' : ''}`}
                    onClick={() => onSelect?.(item)}
                  >
                    <span className="support-history__item-title">
                      {STATUS_LABEL[item.status] || item.status || '—'}
                      {item.sessionNo ? ` · ${item.sessionNo}` : ''}
                    </span>
                    <span className="support-history__item-meta">
                      {formatWhen(item)}
                      {item.category ? ` · ${item.category}` : ''}
                      {!compact && item.endReason ? ` · ${item.endReason}` : ''}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
